import { render } from "./BusinessDetails.vue?vue&type=template&id=60031d76"
import script from "./BusinessDetails.vue?vue&type=script&lang=js"
export * from "./BusinessDetails.vue?vue&type=script&lang=js"

import "./BusinessDetails.vue?vue&type=style&index=0&id=60031d76&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__